/**
 * Geography-oriented message path utils
 */

import { CanonicalDataType } from "./MessagePathRecord";

export type LatitudeDataType =
  | CanonicalDataType.LatDegFloat
  | CanonicalDataType.LatDegInt
  | CanonicalDataType.Number;

export type LongitudeDataType =
  | CanonicalDataType.LonDegFloat
  | CanonicalDataType.LonDegInt
  | CanonicalDataType.Number;

export function isLatitudeType(
  dataType: CanonicalDataType,
): dataType is LatitudeDataType {
  return (
    dataType === CanonicalDataType.LatDegFloat ||
    dataType === CanonicalDataType.LatDegInt ||
    dataType === CanonicalDataType.Number
  );
}

export function isLongitudeType(
  dataType: CanonicalDataType,
): dataType is LongitudeDataType {
  return (
    dataType === CanonicalDataType.LonDegFloat ||
    dataType === CanonicalDataType.LonDegInt ||
    dataType === CanonicalDataType.Number
  );
}

export function isGeoSpecificType(dataType: CanonicalDataType): boolean {
  return (
    dataType === CanonicalDataType.LatDegFloat ||
    dataType === CanonicalDataType.LatDegInt ||
    dataType === CanonicalDataType.LonDegFloat ||
    dataType === CanonicalDataType.LonDegInt
  );
}

export function getCorrespondingGeoType(
  initialType: CanonicalDataType,
): CanonicalDataType[] {
  switch (initialType) {
    case CanonicalDataType.LatDegFloat:
      return [CanonicalDataType.LonDegFloat];
    case CanonicalDataType.LonDegFloat:
      return [CanonicalDataType.LatDegFloat];
    case CanonicalDataType.LatDegInt:
      return [CanonicalDataType.LonDegInt];
    case CanonicalDataType.LonDegInt:
      return [CanonicalDataType.LatDegInt];
    case CanonicalDataType.Number:
      return [
        CanonicalDataType.LatDegFloat,
        CanonicalDataType.LonDegFloat,
        CanonicalDataType.LatDegInt,
        CanonicalDataType.LonDegInt,
        CanonicalDataType.Number,
      ];
    default:
      throw new Error("Unsupported canonical data type");
  }
}
